import React, { ReactNode } from "react";
import { BodyText, Card, CardContent } from "../../../shared/ui";

interface MetricCardProps {
  label: string;
  value: string | number;
  subtext: ReactNode;
  valueColorClass?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  subtext,
  valueColorClass = "text-[#161827]",
}) => {
  return (
    <Card className="min-w-0 rounded-[16px] border border-[#E1E6FF] bg-white shadow-none transition-shadow hover:shadow-xs">
      <CardContent className="flex h-full min-h-[110px] flex-col justify-between p-4 sm:p-5">
        <BodyText className="aku-body-small-regular truncate text-[#6F739B]">
          {label}
        </BodyText>
        <div className="mt-2">
          <p
            className={`aku-heading-h2-medium text-[22px] font-medium tracking-[-0.03em] lg:text-[24px] ${valueColorClass}`}
          >
            {value}
          </p>
          <div className="mt-1.5 aku-label-regular text-[11px] text-[#4C5173]">
            {subtext}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
